import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { useStore, useDispatch } from "react-redux";
import EditDialog, {
  type EditDialogProps,
} from "src/pages/TransactionDetails/Inventory/EditDialog";
import { activeDialogPropsSelector } from "src/store/adminHtml/selector";
import { inventoryByIdSelector } from "src/store/inventory/selector";
import { setActiveDialog } from "src/store/adminHtml/actions";
import ConfirmDialog from "src/components/ConfirmDialog";
import type { EditInventoryProps } from "src/interfaces/adminHtmlState.interface";
import {
  updateInventory,
  deleteInventoryApi,
} from "src/apiService/modules/inventories";

function EditInventoryDialog({ open }: { open: boolean }) {
  const [openDelete, setOpenDelete] = useState(false);
  const [props, setProps] = useState<
    Omit<EditDialogProps, "onClose" | "onSave" | "onDelete" | "loading">
  >({
    open: false,
  });
  const store = useStore();
  const dispatch = useDispatch();
  const updatedRef = useRef(false);

  useEffect(() => {
    if (!open) {
      setProps((p) => ({ ...p, open: false }));
      setOpenDelete(false);
      updatedRef.current = false;
      return;
    }

    const state = store.getState();
    const activeDialogProps = activeDialogPropsSelector(
      state
    ) as EditInventoryProps;
    if (!activeDialogProps?.id) return;
    const data = inventoryByIdSelector(state, activeDialogProps.id);
    if (!data) return;
    setProps({
      open: true,
      data,
    });
  }, [open, store]);

  return (
    <>
      <ConfirmDialog
        open={props.open && openDelete}
        title="Confirm"
        text="Are you sure you want to delete the inventory item?"
        onCancel={() => {
          setOpenDelete(false);
        }}
        onConfirm={async () => {
          if (props.data?.id) {
            await deleteInventoryApi(props.data.id);
            updatedRef.current = true;
          }
          toast.success("Inventory item deleted successfully!");

          setOpenDelete(false);
          const state = store.getState();
          const activeDialogProps = activeDialogPropsSelector(
            state
          ) as EditInventoryProps;
          dispatch(
            setActiveDialog("", {
              requestId: activeDialogProps?.requestId,
              updated: updatedRef.current,
            })
          );
          updatedRef.current = false;
        }}
      />
      <EditDialog
        {...props}
        onDelete={() => {
          setOpenDelete(true);
        }}
        onClose={() => {
          const state = store.getState();
          const activeDialogProps = activeDialogPropsSelector(
            state
          ) as EditInventoryProps;
          dispatch(
            setActiveDialog("", {
              requestId: activeDialogProps?.requestId,
              updated: updatedRef.current,
            })
          );
          updatedRef.current = false;
        }}
        onSave={async (item) => {
          await updateInventory(item);
          updatedRef.current = true;
        }}
      />
    </>
  );
}

export default EditInventoryDialog;
